
import { defineComponent } from "vue";

import {
  ColumnDefinition,
  OptionType,
  BaseButton,
  DeleteIcon,
  NorthIcon,
  SouthIcon,
  FormFieldMultiSelect,
  FormField,
  BaseTable,
} from "@tager/admin-ui";
import { Nullable } from "@tager/admin-services";

import { moveItem } from "@/views/BasisProductForm/BasisProductForm.helpers";

const COLUMN_DEFS: Array<ColumnDefinition> = [
  {
    id: 1,
    name: "Название",
    field: "label",
    style: { width: "25%" },
    headStyle: { width: "25%" },
  },
  {
    id: 2,
    name: "Поля",
    field: "fields",
    style: { width: "25%" },
    headStyle: { width: "25%" },
  },
  {
    id: 3,
    name: "Описание",
    field: "description",
    style: { width: "25%" },
    headStyle: { width: "25%" },
  },
  {
    id: 4,
    name: "Коэффицент",
    field: "coefficient",
    style: { width: "25%" },
    headStyle: { width: "25%" },
  },
  {
    id: 5,
    name: "",
    field: "actions",
    style: { width: "140px", textAlign: "center", whiteSpace: "nowrap" },
    headStyle: { width: "140px", textAlign: "center" },
  },
];

type Props = Readonly<{
  filters: Array<{
    label: string;
    fields: Array<OptionType<number>>;
    description: string;
    coefficient: string;
  }>;
}>;

export default defineComponent({
  name: "FilterTable",
  components: {
    BaseButton,
    DeleteIcon,
    NorthIcon,
    SouthIcon,
    FormFieldMultiSelect,
    FormField,
    BaseTable,
  },
  props: {
    fieldOptionList: {
      type: Array,
      required: true,
    },
    filters: {
      type: Array,
      required: true,
    },
  },
  setup(props) {
    function removeField(rowIndex: number) {
      props.filters.splice(rowIndex, 1);
    }

    function handleClick(
      itemList: Array<{ id: Nullable<number>; name: string }>,
      itemIndex: number,
      direction: "up" | "down"
    ) {
      moveItem<{ id: Nullable<number>; name: string }>(
        itemList,
        itemIndex,
        direction
      );
    }

    function addElement() {
      props.filters.push({
        label: "",
        fields: [],
        description: "",
        coefficient: "",
      });
    }

    return {
      columnDefs: COLUMN_DEFS,
      removeField,
      handleClick,
      addElement,
    };
  },
});
